import { useCallback, useEffect, useRef, useState } from 'react';

export const useGoalSelectorState = ({
  value: valueFromProps,
  onChange: onChangeFromProps,
}) => {
  const prevValueRef = useRef(null);
  const [value, setValue] = useState(valueFromProps.map(cmp => ({ value: String(cmp.Id), content: cmp.Name, data: cmp })));

  const onChange = useCallback((newSelectedGoal) => {
    setValue(newSelectedGoal);

    onChangeFromProps(newSelectedGoal.map(({ data }) => data));
  }, [onChangeFromProps]);

  useEffect(() => {
    if (prevValueRef.current !== valueFromProps) {
      setValue(valueFromProps.map(cmp => ({ value: String(cmp.Id), content: cmp.Name, data: cmp })));

      prevValueRef.current = valueFromProps;
    }
  }, [valueFromProps]);

  return {
    value,
    onChange,
  };
};
